import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import React from 'react'

const CAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY

const CaptchaWrapper = ({ children }) =>
  CAPTCHA_KEY ? <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_KEY}>{children}</GoogleReCaptchaProvider> : children

export default CaptchaWrapper
